import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import PdfIcon from 'svg/PdfIcon';
import styles from '../ProductItems.module.css';
import {
  FLEXI_24_ACCOUNTANTS_URL,
  FLEXI_24_BROKERS_URL,
} from './productGuidesLinks';

export const Flexi24 = () => {
  const { introducerType } = useIntroducerContext();
  const isAccountant = introducerType === 'accountant';

  const getPDFDownloadHref = () => {
    return isAccountant ? FLEXI_24_ACCOUNTANTS_URL : FLEXI_24_BROKERS_URL;
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>24 months</h2>
      <p className={styles.intro}>Popular with you, popular with customers.</p>
      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Borrow over</span>
          <strong>24 months</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Rates from</span>
          <strong>1.95%</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Withdrawal fee</span>
          <strong>0-9%</strong>
        </li>
      </ul>
      <div className={styles.footer}>
        <PdfIcon />
        <a href={getPDFDownloadHref()} target="_blank" rel="noreferrer">
          24 months guide
        </a>
      </div>
    </div>
  );
};
